import * as React from 'react';
import Modal from '../../../Modal';
import { useTranslation } from 'react-i18next';
import Tabs from '../../../Tabs/Tabs';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../../../utils';
import SlideBottom from '../../../SlideBottom/components/SlideBottom';
import SwipeableViews from 'react-swipeable-views';
import SendTickets from './components/SendTickets/SendTickets';
import { useTheme } from '../../../theme';
import Download from './components/Download/Download';
const DOWNLOAD_TAB = 0;
const SEND_TO_EMAIL_TAB = 1;
const TicketsModal = ({ open, onClose, everyPortPassengerIds, withEveryTravelServices }) => {
    const [tab, setTab] = React.useState(DOWNLOAD_TAB);
    const { t } = useTranslation('FlightInfoCard');
    const theme = useTheme('FlightInfoCard').TicketsModal;
    const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });
    const tabs = [
        {
            header: t('Download'),
            label: null,
            value: DOWNLOAD_TAB
        },
        {
            header: t('Send to email'),
            label: null,
            value: SEND_TO_EMAIL_TAB
        }
    ];
    const renderContent = () => {
        return (React.createElement("div", null,
            !isMobile && React.createElement("div", { className: theme.header }, t('Tickets, documents')),
            React.createElement(Tabs, { indicatorClassName: theme.indicator, tabHeaderClassName: theme.tabHeader, rootTabsClassName: theme.tabs, tabs: tabs, onChange: setTab, selected: tab }),
            React.createElement(SwipeableViews, { index: tab, disabled: true },
                React.createElement(Download, { everyPortPassengerIds: everyPortPassengerIds, withEveryTravelServices: withEveryTravelServices }),
                React.createElement("div", null,
                    React.createElement(SendTickets, null)))));
    };
    return !isMobile ? (React.createElement(Modal, { open: open, maxWidth: 'xs', onClose: onClose, slideUp: isMobile }, renderContent())) : (React.createElement(SlideBottom, { header: t('Tickets, documents'), isOpen: open, onClose: onClose, wrapperClassName: theme.slideUpWrapper, className: theme.slideUp, headerClassName: theme.slideUp__header }, renderContent()));
};
export default TicketsModal;
